<template>
    <div class="backend-container deal-share deal-search">
        <BackendHeader />
        <h1>Deal Search</h1>
        <div class="deal-search-search-section">
            <div class="deal-search-one">
                <div>
                    <div class="input-label">Search Text</div>
                    <div class="input-container"><input v-model="searchQuery" placeholder="Search..." @input="clear()" /></div>
                </div>
            </div>
            <div class="deal-search-two">
                <div>
                    <div class="input-label">Min Price</div>
                    <div class="input-container"><input v-model="minPrice" placeholder="Min Price" @input="clear()" /></div>
                </div>
                <div>
                    <div class="input-label">Max Price</div>
                    <div class="input-container"><input v-model="maxPrice" placeholder="Max Price" @input="clear()" /></div>
                </div>
            </div>
            <div class="deal-search-two">
                <div>
                    <div class="input-label">Min % Off</div>
                    <div class="input-container"><input v-model="minPctOff" placeholder="Min % Off" @input="clear()" /></div>
                </div>
                <div>
                    <div class="input-label">Max % Off</div>
                    <div class="input-container"><input v-model="maxPctOff" placeholder="Max % Off" @input="clear()" /></div>
                </div>
            </div>
            <div class="deal-search-one">
                <div class="input-checkbox-container"><input type="checkbox" v-model="onlyPrime" @change="clear()" />Prime Only</div>
            </div>
        </div>
        <div class="deal-search-buttons">
            <button @click="search" :disabled="!searchQuery" class="button">GENERATE</button>
        </div>
        <div>
            <textarea v-model="generatedLink" readonly ref="textarea" />
        </div>
        <div class="deal-search-buttons" v-show="generatedLink">
            <a v-show="!copied" class="promo-copy-code" @click="copyToClipboard" >COPY</a>
            <a v-show="copied" class="promo-copy-code copied" >COPIED</a>
            <a :href="generatedLink" target="_blank">GO TO DEAL</a>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import BackendHeader from '@/components/BackendHeader.vue'

export default defineComponent({
    name: "DealSearch",
    components: {
        BackendHeader
    },
    setup() {
        const searchQuery = ref<string | null>(null)
        const minPrice = ref<string | null>(null)
        const maxPrice = ref<string | null>(null)
        const minPctOff = ref<string | null>(null)
        const maxPctOff = ref<string | null>(null)
        const onlyPrime = ref<boolean>(true)
        const generatedLink = ref<string | null>(null)
        const copied = ref<boolean>(false)
        const textarea = ref<HTMLTextAreaElement | null>(null)

        const convertToMilitaryStyle = (input: string | number): string => {
            const amount = typeof input === 'string' ? parseFloat(input) : input
            const roundedValue = Math.round(amount * 100) / 100
            const value = Math.round(roundedValue * 100)
            return value.toString()
        }

        const convertForPctOff = (input: string | number): string => {
            const amount = typeof input === 'string' ? parseFloat(input) : input
            const roundedValue = Math.round(amount * 100) / 100
            const value = Math.round(roundedValue)
            return value.toString()
        }

        const search = (): void => {
            generatedLink.value = null

            setTimeout(() => {
                let url = `https://www.amazon.com/s?k=${searchQuery.value}&rh=`
                //free shipping
                url += 'p_76:2661625011'

                //min max
                if (minPrice.value && maxPrice.value) {
                    url += `,p_36:${convertToMilitaryStyle(minPrice.value)}-${convertToMilitaryStyle(maxPrice.value)}`
                }
                else if (minPrice.value) {
                    url += `,p_36:${convertToMilitaryStyle(minPrice.value)}-`
                }
                else if (maxPrice.value) {
                    url += `,p_36:-${convertToMilitaryStyle(maxPrice.value)}`
                }

                //pct off
                if (minPctOff.value && maxPctOff.value) {
                    url += `,p_75:${convertForPctOff(minPctOff.value)}-${convertForPctOff(maxPctOff.value)}`
                }
                else if (minPctOff.value) {
                    url += `,p_75:${convertForPctOff(minPctOff.value)}-`
                }
                else if (maxPctOff.value) {
                    url += `,p_75:-${convertForPctOff(maxPctOff.value)}`
                }

                //prime only
                if (onlyPrime.value) {
                    url += `,p_85:2470955011`
                }

                generatedLink.value = url
            }, 500)
        }

        const copyToClipboard = (): void => {
            if (textarea.value) {
                textarea.value.select()
                document.execCommand("copy")
                copied.value = true
                setTimeout(() => {
                    copied.value = false
                }, 2000)
            }
        }

        const clear = (): void => {
            generatedLink.value = null
        }

        return {
            searchQuery,
            minPrice,
            maxPrice,
            minPctOff,
            maxPctOff,
            onlyPrime,
            generatedLink,
            copied,
            textarea,
            search,
            copyToClipboard,
            clear
        }
    }
})
</script>

<style>
    .deal-search .input-label {
        font-size: 10pt;
    }

    .deal-search-search-section {
        display: flex;
        flex-direction: column;
        gap: 7px;
    }

    .deal-search-two {
        display: flex;
        width: 350px;
        gap: 15px;
    }

    .deal-search textarea {
        height: 110px;
        width: 350px;
    }

    .deal-search .input-container input {
        height: 30px;
        display: block;
        width: 100%;
        padding-left: 5px;
    }

    .deal-search-buttons {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .deal-search-buttons {
        display: flex;
        align-items: center;
        gap: 35px;
    }
</style>